import {Component, OnChanges, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {AlertService, UserService} from '../_services';
import {ConfigFieldsComponent} from "../_directives";
import {tinyMCESingleLine, tinyMCETTextOnly} from "../_helpers";

@Component({
  moduleId: module.id.toString(),
  selector: 'shipping-system-label-fields',
  templateUrl: './shipping-system-label-fields.component.html'
})
export class ShippingSystemLabelFieldsComponent extends ConfigFieldsComponent implements OnInit, OnChanges {
  editorInitCallback = tinyMCETTextOnly;
  editorSetupCallback = tinyMCESingleLine;
  labelVariables: any[] = [
    {value: '{order_id}', text: 'Order ID'},
    {value: '{rma_number}', text: 'RMA Number'},
  ];

  constructor(
    protected router: Router,
    protected location: Location,
    protected alertService: AlertService,
    protected userService: UserService
  ) {
    super(router, location, alertService, userService);
  }
}
